'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarRegionStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  spread: _propTypes2.default.bool,
  scrollable: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  scrollableMinHeight: _propTypes2.default.number,
  theme: _propTypes2.default.object
};
var defaultProps = {
  spread: false,
  scrollable: false,
  bordered: false,
  scrollableMinHeight: 200
};
/** Prop Receivers */

var spread = function spread(_ref) {
  var spread = _ref.spread;
  return spread ? 'flex-grow: 1;' : '';
};

var scrollable = function scrollable(_ref2) {
  var scrollable = _ref2.scrollable,
      scrollableMinHeight = _ref2.scrollableMinHeight,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var minHeightSource = scrollableMinHeight || theme.reactackle.components.sidebar.region.scrollableMinHeight;
  return scrollable ? (0, _styledComponents.css)(['overflow-y:auto;overflow-x:hidden;min-height:', ';'], (0, _reactackleCore.getValueString)(minHeightSource)) : 'flex-shrink: 0;';
};

var bordered = function bordered(_ref3) {
  var themeFromProvider = _ref3.theme,
      bordered = _ref3.bordered;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.sidebar.region.border,
      thickness = _theme$reactackle$com.thickness,
      color = _theme$reactackle$com.color;
  return bordered ? 'border: ' + (0, _reactackleCore.getValueString)(thickness) + ' solid ' + color + ';' : '';
};
/** Styles */


var SidebarRegionStyled = exports.SidebarRegionStyled = _styledComponents2.default.div.withConfig({
  displayName: 'SidebarRegionStyled'
})(['display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;', ' ', ' ', ';'], spread, bordered, scrollable);

SidebarRegionStyled.propTypes = propTypes;
SidebarRegionStyled.defaultProps = defaultProps;
SidebarRegionStyled.displayName = 'SidebarRegionStyled';